import React, { useEffect } from 'react';

// The assistant's face in the toolbar: idle art, an animated GIF while it works, and the
// "done" art once the answer or the placement has landed. Plain static files, served from
// the same image folder as the rest of the app's artwork.
export const AI_ICON_SOURCES = {
    idle: '/static/asset/img/ai-assistant-idle.svg',
    working: '/static/asset/img/ai-assistant-loading.gif',
    done: '/static/asset/img/ai-assistant-done.svg',
    // The board being tidied: the same drawing-with-a-marker animation, shown large in the overlay.
    tidying: '/static/asset/img/ai-assistant-loading.gif',
};

let preloaded = false;
const preload = () => {
    if (preloaded || typeof Image === 'undefined') return;
    preloaded = true;
    Object.values(AI_ICON_SOURCES).forEach((src) => {
        const img = new Image();
        img.src = src;
    });
};

const AIAssistantStateIcon = ({ state = 'idle', size = 28, className, style }) => {
    // Warm the cache so the first switch to the working / done art does not flash.
    useEffect(preload, []);
    return (
        <img
            src={AI_ICON_SOURCES[state] || AI_ICON_SOURCES.idle}
            alt=''
            width={size}
            height={size}
            draggable={false}
            className={className}
            style={{ display: 'block', borderRadius: Math.round(size * 0.22), ...style }}
        />
    );
};

export default AIAssistantStateIcon;
